import faker from 'faker'
import labels from 'src/../config/label.js'

export const mocker = {
  poll () {
    let mockPolls = []
    let mockPoll = {}
    let mockChoices = []
    let mockChoice = {}
    let mockTotolVote = 0
    let mockHasImage = 'N'
    let mockSelected = false
    let hasSelected = 'N'
    let pollAmount = Math.floor((Math.random() * 10))
    let choiceAmount = Math.floor((Math.random() * 5))
    for (var i = 0; i < pollAmount; i++) {
      mockChoices = []
      mockTotolVote = 0
      hasSelected = 'N'
      mockHasImage = (Math.random() >= 0.5) ? 'Y' : 'N'
      choiceAmount = Math.floor((Math.random() * 8) + 2)
      for (var j = 0; j < choiceAmount; j++) {
        if (hasSelected === 'Y') {
          mockSelected = 'N'
        } else {
          mockSelected = (Math.random() >= 0.5) ? 'Y' : 'N'
        }
        if (mockSelected === 'Y') {
          hasSelected = 'Y'
        }
        mockChoice = {
          image: (mockHasImage === 'Y') ? faker.image.avatar() : '',
          text: faker.lorem.word(),
          number: Math.floor((Math.random() * 10) + 1),
          selected: mockSelected
        }
        mockTotolVote += mockChoice.number
        mockChoices.push(mockChoice)
      }
      let choices = {
        total: choiceAmount,
        rows: mockChoices
      }
      mockPoll = {
        codpoll: faker.lorem.word(),
        topic: faker.lorem.sentence(),
        hasImage: mockHasImage,
        choices: choices.rows,
        maxChoices: 5,
        addChoice: (Math.random() >= 0.5),
        totalVote: mockTotolVote,
        dateRange: faker.date.past().toString().substr(4, 12) + ' - ' + faker.date.future().toString().substr(4, 12)
      }
      mockPolls.push(mockPoll)
    }

    return {
      total: pollAmount,
      rows: mockPolls
    }
  },
  pathImage () {
    return {
      save: '\\\\192.168.2.18\\document\\Polld',
      load: 'https://192.168.2.81:8443/file_uploads/Polld/'
    }
  },
  savePoll () {
    let message = labels.mockPostMessage
    message.codpoll = faker.lorem.word()
    return message
  },
  saveChoice () {
    let message = labels.mockPostMessage
    message.numseq = 1
    return message
  },
  saveSelectChoice () {
    return labels.mockPostMessage
  },
  deleteChoice () {
    return labels.mockPostMessage
  }
}




// WEBPACK FOOTER //
// ./src/api/poll/mocker.js